
import { Component, Prop, Vue } from 'vue-property-decorator';
import { StoresStore } from '@/store/modules/Warehouse/Warehouse';
import { IWarehouse } from '@/entity/warehouse/Warehouse.types';
import ServiceGeneralProductsCreateForm, { ConsumablesTypeForm } from '@/form/serviceGeneral/serviceGeneralProductsCreate';
import { getStudioId } from "@/UI/lib/state";
import {ProductsStockStore} from "@/store/modules/Warehouse/ProductsStock";
import {ProductsStock} from "@/entity/warehouse/Products/ProductsStock.types";

@Component({
    components: {}
})

export default class ServiceProductsModalForm extends Vue {
  @Prop() forms!: ServiceGeneralProductsCreateForm

  stockDelay: any;
  storageDelay = null;
  unit = '';

  get stocks(): ProductsStock | null {
    return ProductsStockStore.items
  }
  get stores(): IWarehouse | null {
    return StoresStore.warehouse;
  }

  deleteValue(index: number) {
    this.forms.product_list.splice(index, 1)
  }
  addValue() {
    const form = new ConsumablesTypeForm()
    this.forms.product_list.push(form)
  }
  async handleStoragesChange(value: any): Promise<void> {
    await ProductsStockStore.fetchAll({filter: {salon_id: getStudioId(this), store_id: value}})
  }
  handleProductsSearch(value: any) {
    clearTimeout(this.stockDelay);
    this.stockDelay = setTimeout(async () => {
      await ProductsStockStore.fetchAll({filter: {salon_id: getStudioId(this), name: value}})
    }, 500)
  }
  handleProductsChange(value: any, index: any) {
    if(this.stocks && value)
    {
      const product = this.stocks.data.find((element) => {
        return element.id == value;
      });

      if(product) {
        this.forms.product_list[index].store_id = product.store_id;
        this.forms.product_list[index].unit = product.nomenclature.writeoff_unit.symbol;
      }
    }
  }

  async created(): Promise<void>{
    await StoresStore.fetchAll({filter: {salon_id: getStudioId(this)}})
    await ProductsStockStore.fetchAll({filter: {salon_id: getStudioId(this)}})
  }
}
